module.exports = {"Administración de planillas de salarios":"Administración de planillas de salarios","Listado de planillas de salarios":"Listado de planillas de salarios","Ver planilla de salario":"Ver planilla de salario","Editar planilla de salario":"Editar planilla de salario","Nueva planilla de salario":"Nueva planilla de salario","Nombre Empleado":"Nombre Empleado","Apellido Empleado":"Apellido Empleado","Salario fijo":"Salario fijo","Salario base":"Salario base","Jornal diario":"Jornal diario"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/planillas-salarios/es.json
// module id = 1696
// module chunks = 0